module.exports = __webpack_public_path__ + "static/media/Parallelepiped.03d45cf8.svg";